import Text from 'components/shared/Typography/Text';
import i18n from 'i18n';

const textProps = { accent: true, size: 'small' };

export const renderLeftContentDefault = ({ preparedFor, title, travelDates }) => (
  <>
    {preparedFor && <Text {...textProps}>{`${i18n.t('proposal_content.prepared_for')} ${preparedFor}`}</Text>}
    <Text {...textProps}>{title}</Text>
    <Text {...textProps}>{travelDates}</Text>
  </>
);

export const renderRightContentDefault = ({ companyName, email, phone }) => (
  <>
    <Text {...textProps}>{companyName}</Text>
    <Text {...textProps}>{email}</Text>
    <Text {...textProps}>{phone}</Text>
  </>
);
